import { useState, useContext, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import UserContext from "../UserContext";
import "./Register.css";
import "../styles/login.css";
import Logoname from "../img/logo/logo-name.png";
import ImgPhone from "../img/site/phone.png";
import AppStore from "../img/logo/app-store.png";
import PlayStore from "../img/logo/google-play.png";
import { LoadingOutlined } from "@ant-design/icons";
import useQuery from "../utils/useQuery";
import SEO from "../Components/SEO"

export default function Login() {
  const { loginUser, user, mode } = useContext(UserContext);
  const [identifier, setidentifier] = useState("");
  const [password, setpassword] = useState("");
  const [loading, setLoading] = useState(false);

  const query = useQuery();
  const redirect_url = query.get("redirect_url");

  const history = useHistory();

  if (user.token) {
    history.push(
      redirect_url && redirect_url?.startsWith("/") ? redirect_url : "/"
    );
  }
  const handleidentifier = (e) => {
    setidentifier(e.target.value);
  };
  const handlepassword = (e) => {
    setpassword(e.target.value);
  };
  const login = async (e) => {
    e.preventDefault();
    setLoading(true);
    let { message, success, error } = await loginUser(
      { identifier, password },
      "login"
    );
    if (success) {
      window.Toast.fire({
        icon: "success",
        title: message || "Worked as expected",
      });
      history.push(
        redirect_url && redirect_url?.startsWith("/") ? redirect_url : "/"
      );
    } else {
      window.displayToastError(error);
    }
    setLoading(false);
  };
  // setting the theme
  const [dark, setDark] = useState(false);
  useEffect(() => {
    let darkmode = localStorage.getItem("darkmode")
      ? JSON.parse(localStorage.getItem("darkmode"))
      : false;
    setDark(darkmode);
  }, [mode]);
  return (
    <>
      <SEO title="Sign In To Twika"></SEO>
      <div className={dark ? "w-full darkmode" : "w-full"}>
        <div className="">
          <div className="lg:flex gap-5 justify-center">
            <div className="w-1/4  hidden lg:block">
              <div className="flex justify-center">
                <img src={ImgPhone} alt="Twika showcase" />
              </div>
            </div>

            <div className="lg:w-1/4 p-0 mt-100">
              <div className="form-container border">
                <div className="logo-name w-full flex justify-center">
                  <img src={Logoname} alt="Our logo name" />
                </div>
                <div className="inputs-group">
                  <p className="my-2">
                    Sign up to see stories, photos and <br />
                    events from your hommies.
                  </p>
                  <form onSubmit={login}>
                    <div className="form-group">
                      <input
                        autoComplete="off"
                        type="text"
                        id="username"
                        placeholder="Username or Email"
                        value={identifier}
                        onChange={handleidentifier}
                        className="form-control"
                      />
                    </div>

                    <div className="form-group">
                      <input
                        className="form-control"
                        autoComplete="off"
                        type="password"
                        id="password"
                        placeholder="Password"
                        value={password}
                        onChange={handlepassword}
                      />
                    </div>

                    <div className="form-group">
                      {loading ? (
                        <button
                          type="submit"
                          className="p-2 rounded-md bg-fire w-100 text-white opacity-50 gap-1 flex items-center justify-center"
                          style={{ fontSize: "13px" }}
                          disabled
                        >
                          {" "}
                          <LoadingOutlined /> <span>Signing ...</span>
                        </button>
                      ) : (
                        <button
                          type="submit"
                          className="p-2 rounded-md bg-fire w-100 text-white
                        focus:outline-none
                        "
                          style={{ fontSize: "13px" }}
                        >
                          Sign In
                        </button>
                      )}

                      <div className="flex justify-end mt-2 ">
                        <Link
                          to="/reset-password"
                          className="text-gray-500 hover:underline"
                        >
                          Forgot password?
                        </Link>
                      </div>
                    </div>
                  </form>
                </div>
              </div>

              <div className="border mt-1 p-1 flex justify-center items-center">
                <span className="">
                  Don't have any account?{" "}
                  <b>
                    <Link
                      to={`/register${
                        redirect_url ? "?redirect_url=" + redirect_url : ""
                      }`}
                    >
                      Create One.
                    </Link>
                  </b>
                </span>
              </div>
              {!dark && (
                <div className="mt-1 p-1 form-container">
                  <div className="account2">
                    <div className="app-stores flex w-full justify-center">
                      <img src={AppStore} alt="App Store" className="mr-2" />
                      <img
                        src={PlayStore}
                        alt="Google Play Store"
                        className="ml-2"
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* <LoginFooter /> */}
      </div>
    </>
  );
}
